import { Next } from "@contentful/rich-text-html-renderer";
import { Block, Inline } from "@contentful/rich-text-types";

export function renderLink(node: Block | Inline, next: Next) {
    return `<inlineLink id="${node.data.target.sys.id}" linkType="${node.data.target.sys.linkType}" nodeType="${node.nodeType}">${next(node.content)}</inlineLink>`;
}
